<template>
    <div class="main">
        <c-panel>
            <form-exemplar :paramId="$route.params.id" v-on:onSubmitExemplar="onSubmitExemplar"></form-exemplar>
        </c-panel>
    </div>
</template>
<script>
import formExemplar from "./form"

export default {
    methods:{
        onSubmitExemplar(){
            this.$router.push('/admin/biblioteca/exemplar');
        }
    },
    components:{ formExemplar }
}
</script>

